import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Routes, Navigate, Route, useLocation } from 'react-router-dom';

import { finleyAssert } from '@finley-technologies/common';

import { HomeRoute } from './HomeRoute';
import { SignupRoute } from './SignupRoute';
import { useUserAuthUnsafe } from '~/contexts/UserAuthProvider';

const Auth0Callback = () => {
  const location = useLocation();
  const { login } = useUserAuthUnsafe();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  finleyAssert(token, 'Unable to get access token from SSO Authentication.');

  login(token, '/');

  return <Skeleton />;
};

export const LoggedOutRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/auth0-callback" element={<Auth0Callback />} />
      <Route path="/signup" element={<SignupRoute />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  );
};
